import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Utils } from '../../../core/Utils';

import { ICourseEqualizationAssigned, ICourseEqualizationListItem } from '../../../models/CourseEqualization';
import { IPersonSearchResultItem } from '../../../models/Person';
import { AppService } from '../../../services/app.service';
import { CourseEqualizationService } from '../../../services/course-equalization.service';
import { PersonService } from '../../../services/person.service';
import { ITableColumn } from '../../../shared/table/table.component';
import { store } from '../shared';

@Component({
    selector: 'app-course-equalization-list',
    templateUrl: './course-equalization-list.component.html'
})
export class CourseEqualizationListComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: CourseEqualizationService,
        private persons: PersonService,
        private route: ActivatedRoute
    ) {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth();
        const day = today.getDate();

        this.assignedDateFrom = new Date(year - 1, month, day);
        this.assignedDateTo = new Date(year, month, day);
    }

    items: ICourseEqualizationListItem[] = [];

    canPickStudent: boolean;
    canEdit: boolean;
    canViewAssigned: boolean;
    studentPickerOpened: boolean;
    student: IPersonSearchResultItem;

    assignedDateFrom: Date;
    assignedDateTo: Date;
    assignedSearch: string;
    assignedStatus: string[] = [];
    assignedStatusOptions: string[] = [];

    get assignedItems(): ICourseEqualizationAssigned[] {
        const text = (this.assignedSearch || '').toLowerCase();
        const status = this.assignedStatus;

        if (!text && !status.length) return this.assignedAll;

        return this.assignedAll.filter(t => {
            if (status.length && status.includes(t.Status)) return true;
            if (text && (t.Email.toLowerCase().includes(text)
                || t.Speciality.toLowerCase().includes(text)
                || `${t.Name} ${t.Surname}`.toLowerCase().includes(text))) return true;
            return false;
        });
    }

    private assignedAll: ICourseEqualizationAssigned[] = [];

    readonly columns: ITableColumn[] = [
        { property: 'Status', label: 'courseEqualization_lblStatus', cssClass: 'hidden-sm-down' },
        { property: 'Speciality', label: 'courseEqualization_lblSpecialityYearCreated', cssClass: 'hidden-sm-down hidden-lg-up' },
        { property: 'Speciality', label: 'courseEqualization_lblStatusSpecialityYearCreated', cssClass: 'hidden-md-up' },
        { property: 'Speciality', label: 'courseEqualization_lblSpeciality', cssClass: 'hidden-md-down' },
        { property: 'StudyYear', label: 'courseEqualization_lblStudyYear', cssClass: 'hidden-md-down' },
        { property: 'Created', label: 'courseEqualization_lblCreated', cssClass: 'hidden-md-down' },
        { width: '1px' }
    ];

    readonly assignedColumns: ITableColumn[] = [
        { property: 'Name', label: 'courseEqualization_lblStudent' },
        { property: 'Speciality', label: 'courseEqualization_lblSpeciality', cssClass: 'hidden-md-down' },
        { property: 'StudyYear', label: 'courseEqualization_lblStudyYear', cssClass: 'hidden-sm-down' },
        { property: 'Created', label: 'courseEqualization_lblCreated', cssClass: 'hidden-xs-down' },
        { property: 'Status', label: 'courseEqualization_lblStatus', cssClass: 'hidden-xs-down' },
        { width: '1px' }
    ];

    readonly statusDisplayFn = (option: string) => this.app.translate('courseEqualization_status' + option);

    ngOnInit() {
        const user = this.app.currentUser;

        if (user) {
            this.canEdit = user.rights.indexOf('COURSE_EQUALIZATION.EDIT') > -1;
            this.canPickStudent = user.rights.indexOf('COURSE_EQUALIZATION.SET_STUDENT') > -1;

            if (this.canPickStudent) {
                this.loadAssigned();

                const queryUpn = this.route.snapshot.queryParams['id'];

                if (queryUpn) {
                    this.app.addLoading(this.persons.findStudents('StudentId', queryUpn)).subscribe(data => {
                        if (data.length) {
                            this.setStudent(data[0]);
                            this.loadItems();
                        } else {
                            this.app.showError(this.app.translate('studentNotFound'));
                        }
                    });
                } else {
                    this.student = store.getStudent();

                    if (this.student) {
                        this.loadItems();
                    } else {
                        this.toggleStudentPicker();
                    }
                }
            } else {
                this.loadItems();
            }
        }
    }

    toggleStudentPicker() {
        if (this.studentPickerOpened) {
            this.studentPickerOpened = false;
        } else {
            this.studentPickerOpened = true;
            this.items = [];
        }
    }

    setStudent(student: IPersonSearchResultItem) {
        this.studentPickerOpened = false;
        this.student = student;
        this.loadItems();

        store.setStudent(student);
    }

    delete(row: ICourseEqualizationListItem) {
        this.app.confirm(this.app.translate('confirmItemDelete'), result => {
            if (!result) return;

            this.app.addLoading(this.service.delete(row.Id)).subscribe(() => {
                this.loadItems();
            });
        });
    }

    canDelete(row: ICourseEqualizationListItem) {
        return (this.canEdit && row.Status == 'Draft');
    }

    loadAssigned() {
        const df = Utils.getInputDate(this.assignedDateFrom);
        const dt = Utils.getInputDate(this.assignedDateTo);

        if (df && dt && dt >= df) {
            this.app.addLoading(this.service.getAssigned(df, dt)).subscribe(data => {
                this.assignedAll = data;

                this.assignedStatusOptions = data.reduce((arr, n) => {
                    if (!arr.includes(n.Status)) arr.push(n.Status);
                    return arr;
                }, []);
            });
        }
    }

    private loadItems() {
        this.app.addLoading(this.service.get(this.student?.Email)).subscribe(data => {
            this.items = data;
        });
    }
}
